<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" outlined :color="color" class="ml-3">
        <v-icon>{{ icon }}</v-icon
        ><span v-if="edit === false">Instituição</span>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="close" color="white">mdi-window-close</v-icon>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-row>
            <v-col>
              <v-text-field
                label="Nome da Institução"
                name="nome"
                type="text"
                required
                :rules="[required]"
                v-model="payload.nome"
              ></v-text-field>
            </v-col>
            <v-col>
              <categoria-combobox
                :filter="payload"
                :rules="[requiredArray]"
                ref="categoria"
              ></categoria-combobox>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                label="Nome do Responsável"
                name="nome"
                type="text"
                required
                :rules="[required]"
                v-model="payload.responsavel"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                label="Telefone do Responsável"
                name="nome"
                type="text"
                required
                v-mask="['(##) ####-####', '(##) #####-####']"
                :rules="[required]"
                v-model="payload.telefone"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                label="Email do Responsável"
                name="nome"
                type="text"
                required
                :rules="[required, emailValidator]"
                v-model="payload.email"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                label="Cargo ou Função do responsável"
                name="nome"
                type="text"
                required
                :rules="[required]"
                v-model="payload.cargo"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row
            v-if="
              isFullAdmin ||
              (config.permiteAddMunicipiosInstituicao &&
                groupsConfig.permiteAddMunicipiosInstituicao)
            "
          >
            <v-col>
              <combobox-municipio
                :multiple="true"
                :filter="payload"
                :value="payload.municipios"
                @onChange="(e) => (payload.municipios = e)"
              ></combobox-municipio>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="close">Fechar</v-btn>
        <v-btn color="info" outlined text @click="onConfirm">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { instituicaoAPI } from "../API/instituicaoAPI";
import ComboboxMunicipio from "@/modules/city/components/ComboboxMunicipio.vue";
import { mapActions, mapGetters } from "vuex";
import { CategoriaCombobox } from "@/modules/categoria";
import { required, emailValidator, requiredArray } from "@/helpers/validator";

export default {
  name: "AppModalInsertUr",
  props: {
    object: { type: Object, required: false },
    edit: { type: Boolean, required: false, default: false },
    icon: { type: String, required: true },
    color: { type: String, required: true },
  },
  components: {
    ComboboxMunicipio,
    CategoriaCombobox,
  },
  computed: {
    ...mapGetters(["isFullAdmin"]),
  },
  data() {
    return {
      payload: { categorias: [] },
      dialog: false,
      municipiosRegionais: [],
      required: required,
      emailValidator: emailValidator,
      requiredArray: requiredArray,
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
    };
  },
  mounted() {
    if (this.object && this.edit === true) {
      this.payload = this.object;
      this.payload.municipios = this.object.municipioIds;
      this.payload.categorias =
        this.object.categoria &&
        this.object.categoria.map((item) => item.categoriaInstituicaoId);
      this.$forceUpdate();
    }
  },
  methods: {
    ...mapActions(["setLoading"]),
    close() {
      this.dialog = false;
      this.payload = { categorias: [] };
    },
    async check() {
      const isValid = await this.$refs.form.validate();
      return isValid;
    },
    async onConfirm() {
      const valid = await this.check();
      const categoriaValid = await this.$refs.categoria.check();

      if (!valid || !categoriaValid) return;
      this.setLoading(true);
      const valores = {
        ...this.payload,
        municipioId: this.payload.municipios,
        categoriaId: this.payload.categorias,
      };
      if (this.edit === true) {
        instituicaoAPI
          .update(valores)
          .then((resp) => {
            this.dialog = false;
            this.payload = { categorias: [] };
            this.$emit("on-save");
          })
          .catch((e) => {
            console.log("error on modalinsert Instituição: ", e);
            this.$notification.error("Error ao salvar Instituição");
            this.setLoading(false);
          });
      } else {
        instituicaoAPI
          .create(valores)
          .then((resp) => {
            this.dialog = false;
            this.payload = { categorias: [] };
            this.setLoading(false);

            this.$emit("on-save");
          })
          .catch((e) => {
            console.log("error on modalinsert Instituição: ", e);
            this.$notification.error("Error ao salvar Instituição");
            this.setLoading(false);
          });
      }
    },
  },
};
</script>
